import React, { useState } from 'react';
import DocsCtx from './docsCtx';

const DocsContext = (props) => {
  const [selectedItemsDocIds, setSelectedItemsDocIds] = useState<number[]>([]);
  const [selectedItemsIds, setSelectedItemsIds] = useState<number[]>([]);

  return (
    <DocsCtx.Provider
      value={{
        selectedItemsDocIds: selectedItemsDocIds,
        selectedItemsIds: selectedItemsIds,
        setSelectedItemsDocIds: setSelectedItemsDocIds,
        setSelectedItemsIds: setSelectedItemsIds,
      }}>
      {props.children}
    </DocsCtx.Provider>
  );
};

export default DocsContext;
